import request from '@/utils/request'


// 查询时间树列表
export function listTime(query) {
  return request({
    url: '/tree/time/list',
    method: 'get',
    params: query
  })
}

// 查询时间树分页
export function pageTime(query) {
  return request({
    url: '/tree/time/page',
    method: 'get',
    params: query
  })
}

// 查询时间树详细
export function getTime(data) {
  return request({
    url: '/tree/time/detail',
    method: 'get',
    params: data
  })
}

// 新增时间树
export function addTime(data) {
  return request({
    url: '/tree/time/add',
    method: 'post',
    data: data
  })
}

// 修改时间树
export function updateTime(data) {
  return request({
    url: '/tree/time/edit',
    method: 'post',
    data: data
  })
}

// 删除时间树
export function delTime(data) {
  return request({
    url: '/tree/time/delete',
    method: 'post',
    data: data
  })
}
